<template>
  <el-card :body-style="cardStyle" class="card-box" shadow="hover" @click.native="cardClick">
    <el-image v-if="cardData.resourceCover" class="card-img" fit="cover"
      :src="$config.baseImgURL + 'Article/showPhotograph/' + cardData.resourceCover">
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
    <img class="card-img" v-else  src="../assets/noresource.png" alt=""/>
    <div class="card-item-title">{{ cardData.resourceName }}</div>
    <div class="card-item-tips">{{ cardData.famousTeacherName }}</div>
    <div class="card-item-tips">{{ $dayjs(cardData.creatorTime).format("YYYY-MM-DD") }}</div>
    <el-row :gutter="10">
      <div class="fx card-bottom">
        <el-col :span="9"><span><i class="el-icon-download"></i> {{ cardData.downloads | filterNum }}</span></el-col>
        <el-col :span="9"><i class="el-icon-view"></i> {{ cardData.glanceOvers | filterNum }}</el-col>
        <el-col :span="2" :offset="2">
          <el-button type="primary" size="small" class="card-btn">查看</el-button>
        </el-col>
      </div>
    </el-row>
  </el-card>
</template>
<script>
export default {
  name: 'Card',
  props: {
    cardStyle: {
      default: {}
    },
    cardData: {
      default: function () {
        return {}
      }
    }
  },
  
  methods: {
    cardClick() {
      this.$emit('toDetail')
    }
  }
}
</script>
<style scoped>
.card-box {
  margin-bottom: 25px;
  user-select: none;
  width: 276px;
  height: 344px;
  /* transition: all .5s; */
}

.card-box:hover {
  transform: scale(1.07);
}

.card-img {
  width: 100%;
  height: 169px;
  object-fit: scale-down;
  display: block;
}

.card-item-title {
  font-size: 18px;
  margin: 12px 0 15px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-item-tips {
  /* height: 44px; */
  font-size: 16px;
  color: #ccc;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.card-bottom {
  font-size: 16px;
}

.card-btn {
  padding: 3px 5px;
  /* background: #fd962d; */
  border: none;
}
</style>